import { render } from "./MyAccount.vue?vue&type=template&id=0f245d19"
import script from "./MyAccount.ts?vue&type=script&lang=js"
export * from "./MyAccount.ts?vue&type=script&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=0f245d19&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__